<template>
  <SelectInputView :title="title" :options="options" searchable v-model:query="query" :value="value" :required="required" :multiple="multiple" :disabled="disabled" :max="max" :size="size" :errors="errors" @update:value="$emit('update:value', $event)">
    <template v-slot:option="{ option, preview }">
      <slot name="option" :option="option" :preview="preview"></slot>
    </template>
  </SelectInputView>
</template>

<script setup>
import SelectInputView from "./SelectInputView.vue";
import {computed, ref} from "vue";
import toasts from "../../../plugins/toasts/toasts.js";
import modelSearch from "../../../modelSearch.js";

const props = defineProps({
  title: String,
  value: [Number, String, Boolean, Array],
  required: Boolean,
  multiple: Boolean,
  disabled: Boolean,
  max: Number,
  size: String,
  errors: Array,
  endpoint: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["update:value"]);

const query = ref("");

const options = ref([]);

const identifiers = computed(() => props.value ? Array.isArray(props.value) ? props.value : [props.value] : undefined);

modelSearch.search(props.endpoint, query, identifiers, ({ results, error }) => {
  if (results) {
    options.value = results;
  } else if (error) {
    toasts.create({
      color: "danger",
      content: error?.response?.data?.message ? error.response.data.message : error.message
    });
  }
});

</script>